/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Job } from '../../models/job';
import { JobRequest } from '../../models/job-request';

export interface CreateJob$Params {
   body: JobRequest;
}

export function createJob(
   http: HttpClient,
   rootUrl: string,
   params: CreateJob$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Job>> {
   const rb = new RequestBuilder(rootUrl, createJob.PATH, 'post');
   if (params) {
      rb.body(params.body, 'application/json');
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Job>;
      })
   );
}

createJob.PATH = '/api/weather/job';
